import { axiosClient } from '@services/clients'

// Allowed filter keys for GET /payment-methods
const PAYMENT_METHOD_FILTER_KEYS = ['providerId', 'type', 'enabled']

export async function getPaymentMethods(filters = {}) {
  const params = {}
  PAYMENT_METHOD_FILTER_KEYS.forEach((key) => {
    if (
      filters[key] !== '' &&
      filters[key] !== undefined &&
      filters[key] !== null
    ) {
      params[key] = filters[key]
    }
  })

  const queryString = new URLSearchParams(params).toString()
  const suffix = queryString ? `?${queryString}` : ''

  const {
    data: { result },
  } = await axiosClient(`/payment-methods${suffix}`)
  return result
}

export async function getPaymentMethod(id) {
  const {
    data: { result },
  } = await axiosClient(`/payment-methods/${id}`)
  return result
}

export async function getSiteConfigs(id) {
  const {
    data: { result },
  } = await axiosClient(`/payment-methods/${id}/sites`)
  return result
}

export async function createPaymentMethod(payload) {
  const { data } = await axiosClient.post('/payment-methods', payload)
  return data
}

export async function updatePaymentMethod(id, payload) {
  const { data } = await axiosClient.put(`/payment-methods/${id}`, payload)
  return data
}

export async function deletePaymentMethod(id) {
  const { data } = await axiosClient.delete(`/payment-methods/${id}`)
  return data
}

export async function updateSiteConfig(id, siteId, payload) {
  const { data } = await axiosClient.put(
    `/payment-methods/${id}/sites/${siteId}`,
    payload,
  )
  return data
}

export async function deleteSiteConfig(id, siteId) {
  const { data } = await axiosClient.delete(
    `/payment-methods/${id}/sites/${siteId}`,
  )
  return data
}
